import React from 'react';
import { GridTableCell } from '../GridTableCell/GridTableCell';
import { getPriceView } from '../../../utils/stringUtils';

type PriceCellProps = {
  price: number;
};

const PriceCell = ({ price }: PriceCellProps) => {
  return <GridTableCell className="private-info">{getPriceView(price)}</GridTableCell>;
};

export { PriceCell, type PriceCellProps };
